
export const KMF_CLAIM_PAGE_INDICES = {
    CLAIMENT_DETAILS: 0,
    DECEASED_DETAILS: 1,
    UPLOAD_DOCUMENTS: 2,
    SUCCESS_PAGE: 3
};

export const PAGES = [
    {
        URL:'/ka-metlha-funeral-cover-claim/claiment-details/',
        TITLE:'Claiment Details'
},
    {
        URL:'/ka-metlha-funeral-cover-claim/deceased-details/',
        TITLE:'Deceased Details'
},
    {
        URL:'/ka-metlha-funeral-cover-claim/upload-documents/',
        TITLE:'Upload Documents'
},
    {
        URL:'/ka-metlha-funeral-cover-claim/successful/',
        TITLE:'Success Page'
},
]

export const PROGRESS_BAR_STEPS=[
    {
    title:"Claiment Details",
    isActive:false,
    isCompleted: false,
    },
    {
    title:"Deceased Details",
    isActive:false,
    isCompleted:false,
    },
    {
    title:"Upload Documents",
    isActive:false,
    isCompleted:false,
    },
]